import * as types from '@/store/mutations'

// state
export const stateModel = {
  ig_id: '',
  date_range: [],
  use_global_range: true,
  hashtag_ids: [],
  embeds_uuids: [],
  competitor_ids: [],
  use_global_hashtags: true,
  use_global_competitors: true,
  use_global_account: true,
  use_global_embeds: true,
}

// state
export const state = {
  ...stateModel,
}

// getters
export const getters = {
  ig_id: (state) => state.ig_id,
  date_range: (state) => state.date_range,
  use_global_range: (state) => state.use_global_range,
  hashtag_ids: (state) => state.hashtag_ids,
  embeds_uuids: (state) => state.embeds_uuids,
  competitor_ids: (state) => state.competitor_ids,
  use_global_hashtags: (state) => state.use_global_hashtags,
  use_global_competitors: (state) => state.use_global_competitors,
  use_global_account: (state) => state.use_global_account,
  use_global_embeds: (state) => state.use_global_embeds,
}

// mutations
export const mutations = {
  // cleanup/reset module state. used at logout
  RESET(state) {
    Object.keys(state).forEach((key) => {
      state[key] = stateModel[key]
    })
  },
  [types.SET_IG_ID]: (state, ig_id) => {
    state.ig_id = ig_id
    state.use_global_account = true
  },
  [types.SET_DATE_RANGE]: (state, date_range) => {
    state.date_range = date_range
    state.use_global_range = true
  },
  [types.SET_USE_GLOBAL_RANGE]: (state, use_global_range) => {
    state.use_global_range = use_global_range || false
  },
  [types.SET_HASHTAG_IDS]: (state, hashtag_ids) => {
    state.hashtag_ids = hashtag_ids
    state.use_global_hashtags = true
  },
  [types.SET_EMBEDS_UUIDS]: (state, embeds_uuids) => {
    state.embeds_uuids = embeds_uuids
    state.use_global_embeds = true
  },
  [types.SET_COMPETITOR_IDS]: (state, competitor_ids) => {
    state.competitor_ids = competitor_ids
    state.use_global_competitors = true
  },
  [types.SET_USE_GLOBAL_HASHTAGS]: (state, use_global_hashtags) => {
    state.use_global_hashtags = use_global_hashtags || false
  },
  [types.SET_USE_GLOBAL_ACCOUNT]: (state, use_global_account) => {
    state.use_global_account = use_global_account || false
  },
  [types.SET_USE_GLOBAL_COMPETITORS]: (state, use_global_competitors) => {
    state.use_global_competitors = use_global_competitors || false
  },
}

// actions
export const actions = {
  setIgId({ commit }, ig_id) {
    commit(types.SET_IG_ID, ig_id)
  },
  setDateRange({ commit }, date_range) {
    commit(types.SET_DATE_RANGE, date_range)
  },
  setUseGlobalRange({ commit }, use_global_range) {
    commit(types.SET_USE_GLOBAL_RANGE, use_global_range)
  },
  setHashtagIds({ commit }, hashtag_ids) {
    commit(types.SET_HASHTAG_IDS, hashtag_ids)
  },
  setCompetitorIds({ commit }, competitor_ids) {
    commit(types.SET_COMPETITOR_IDS, competitor_ids)
  },
  // setUseGlobalHashtags({ commit }, use_global_hashtags) {
  //   commit(types.SET_USE_GLOBAL_HASHTAGS, use_global_hashtags);
  // },
  // setUseGlobalCompetitors({ commit }, use_global_competitors) {
  //   commit(types.SET_USE_GLOBAL_COMPETITORS, use_global_competitors);
  // }
}
